import {
    AGENCY_PLAN,
    EXCEL_PLAN,
    FREE_PLAN,
    LAUNCH_PLAN,
    OnlyNewPlanType,
    SCALE_PLAN
} from '@/types/pricingTypes/planType';
import { SocialProfileCountOptionType } from '@/components/pages/settings/subscription-invoices/PlanModal/Components/PlanCard/types';

export const SOCIAL_PROFILE_COUNT_OPTIONS: Record<
    Exclude<OnlyNewPlanType, typeof AGENCY_PLAN | typeof FREE_PLAN>,
    SocialProfileCountOptionType[]
> = {
    [LAUNCH_PLAN]: [{ label: '5 social profiles', value: 5 }],
    [SCALE_PLAN]: [
        { label: '5 social profiles', value: 5 },
        { label: '10 social profiles', value: 10 },
        { label: '15 social profiles', value: 15 },
        { label: '20 social profiles', value: 20 }
    ],
    [EXCEL_PLAN]: [
        { label: '5 social profiles', value: 5 },
        { label: '10 social profiles', value: 10 },
        { label: '15 social profiles', value: 15 },
        { label: '20 social profiles', value: 20 },
        { label: '25 social profiles', value: 25 },
        { label: '30 social profiles', value: 30 },
        { label: '30+ social profiles', value: '30+' }
    ]
} as const;
